// src/hooks/useTicketsData.js
import { useState, useEffect } from 'react';
import {getSalesRepClients} from "../../services/SalesRep/getSalesRepClients"
import {Bounce, toast} from "react-toastify";

interface Client {
    id: number;
    email: string;
    name: string;
    mainPhone: string;
    secondaryPhone: string;
    taxAddress: string;
    clientState: string;
    createdAt: string;
    uniqueCode: string;
    plants: Plant[];  // Assuming `plants` is an array of `Plant` objects
}

interface Plant {
    id: number;
    uniqueCode: string;
    name: string;
    description: string;
    address: string;
    createdAt: string;
    equipments: any[];
}

export const useSalesRepClients = () => {
    const [clients, setClients] = useState<Client[]>([]);
    const [loadingClients, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const getClientsData = async () => {
            try {
                const response:any = await getSalesRepClients();
                setClients(response.data.data.clients);
            } catch (error:any) {
                toast.error("Error al obtener los clientes", {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
            }
            finally {
                setTimeout(() => setLoading(false), 500);
            }
        };
        getClientsData();
    }, []);

    return { clients, loadingClients };
};
